import React from 'react';
import PropTypes from 'prop-types';
import Darts from './darts/darts';

const ExtraInformation = (props) => {
  const { has_data: hasData, type } = props;

  if (!hasData) {
    return null;
  }

  switch (type) {
    case 'darts':
      return <Darts {...props} />;
    default:
      return null;
  }
};

ExtraInformation.propTypes = {
  has_data: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
};

export default ExtraInformation;
